// @ts-strict-ignore
import { Typography } from "@aviary";
import type { TypeaheadResultSelectedV2 } from "@shared/components/CatalogSearch/SearchInput/SearchInput";
import type { Typeahead as TypeaheadType } from "@shared/types/graphqlGenerated";

import type { GroupName } from "../../Typeahead/shared/TypeaheadGroupName";
import type { TypeaheadViewAll } from "../../Typeahead/shared/TypeaheadViewAll";
import { TypeaheadRow } from "../TypeaheadRow/TypeaheadRow";
import { ViewAll } from "../ViewAll/ViewAll";

import * as styles from "./TypeaheadGroup.styles";

type Typeahead = Pick<TypeaheadType, "id" | "entityType" | "name" | "brandName">;

interface Props {
  groupName: GroupName;
  data: Typeahead[];
  query: string;
  highlightRowId: string;
  onResultClick: (result: TypeaheadResultSelectedV2) => void;
  viewAllGroup?: TypeaheadViewAll;
  itemsBeforeGroup?: number;
}

const TypeaheadGroup = ({
  groupName,
  data,
  query,
  highlightRowId,
  onResultClick,
  viewAllGroup,
  itemsBeforeGroup,
}: Props) => {
  const renderRows = () => {
    return data?.map((typeaheadSuggestion, index) => {
      return (
        <TypeaheadRow
          key={typeaheadSuggestion?.id}
          isHighlighted={highlightRowId === typeaheadSuggestion?.id}
          query={query}
          name={typeaheadSuggestion?.name}
          brandName={typeaheadSuggestion?.brandName}
          onClick={() =>
            onResultClick({
              typeaheadSearch: typeaheadSuggestion,
              searchRank: index + 1 + itemsBeforeGroup,
              groupSearchRank: index + 1,
            })
          }
        />
      );
    });
  };

  const renderViewAll = () => {
    if (viewAllGroup) {
      return (
        <ViewAll
          key={viewAllGroup.id}
          onClick={viewAllGroup.onTrigger}
          isHighlighted={highlightRowId === viewAllGroup.id}
        />
      );
    }

    return null;
  };

  return (
    <>
      <Typography type="h5" css={styles.groupTitle}>
        {groupName}
      </Typography>
      {renderRows()}
      {renderViewAll()}
    </>
  );
};

export { TypeaheadGroup };
